var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"measures-swiper-item-mian",class:{ 'measures-swiper-item-mian-mobile': _vm.isMobile}},[_c('div',{staticClass:"header-img"}),_c('div',{staticClass:"content"})])}
var staticRenderFns = []

export { render, staticRenderFns }